import { Theme } from '@mui/material/styles';

export const form = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        alignItems: 'baseline',
    },

    '& .MuiInputBase-root': {
        '& .MuiInputBase-input': {
            padding: `${theme.spacing(1.375)} !important`,
            fontSize: '0.8125rem !important',
            height: '1.1876em !important',
        },
    },

    '& .school-inputs': {
        [theme.breakpoints.up('lg')]: {
            marginRight: theme.spacing(3),
        },

        '&.school-address': {
            [theme.breakpoints.up('lg')]: {
                minWidth: '230px',
            },
        },

        '&.school-zipCode': {
            [theme.breakpoints.up('lg')]: {
                maxWidth: '166px',
            },
        },
    },
}) as const;

export const submit = (theme: Theme) => ({
    minWidth: '85px',
    marginTop: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
        marginTop: 0,
    },
}) as const;

export const text = (theme: Theme) => ({
    fontWeight: 700,
    color: 'text.secondary',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(1),
    },
}) as const;

export const school = (theme: Theme) => ({
    minHeight: '3em',
    borderLeft: '2px solid',
    borderLeftColor: 'schoolBorder.dark',
    paddingY: theme.spacing(1),
    paddingX: theme.spacing(4),
    backgroundColor: 'background.default',
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        alignItems: 'center',
    },
}) as const;

export const schoolTitle = (theme: Theme) => ({
    color: 'schoolTitle.main',
    fontWeight: 400,
    width: '100%',
    paddingBottom: theme.spacing(0.625),
    marginBottom: theme.spacing(1.875),
    borderBottom: '1px solid',
    borderBottomColor: 'schoolBorder.main',

    [theme.breakpoints.up('lg')]: {
        width: '60%',
        paddingBottom: 0,
        marginBottom: 0,
        marginRight: theme.spacing(4.375),
        borderBottom: 'none',
        borderRight: '1px solid',
        borderRightColor: 'schoolBorder.main',
    },
}) as const;

export const schoolBox = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',

    [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '50%',
    },
}) as const;

export const schoolText = (theme: Theme) => ({
    fontSize: 13,
    marginBottom: theme.spacing(0.625),

    [theme.breakpoints.up('lg')]: {
        marginBottom: 0,
    },
}) as const;

export const pagination = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
} as const;

export const paginationText = (theme: Theme) => ({
    marginRight: theme.spacing(2.5),
}) as const;
